import { render, staticRenderFns } from "./View3d.vue?vue&type=template&id=73a0bee4&scoped=true&"
import script from "./View3d.vue?vue&type=script&lang=js&"
export * from "./View3d.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a0bee4",
  null
  
)

export default component.exports